import { css } from '@emotion/react'

const menuWrapper = css`
  z-index: 999;
`

export const styles = {
  menuWrapper,
}
